export default "__VITE_ASSET__Bua6Tr$c__"